<div class="row page-header">
    <div class="col-12">
        <h1>Material Ticket Logs <small>Track material pick ups and deliveries</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Sand/Gravel</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                                    <action-toolbar-buttons
                                        [grid]="grid"
                                        [canEdit]="canEdit"
                                        [showAdd]="true"
                                        [showEdit]="true"
                                        [showDelete]="true"
                                        [showDuplicate]="true"
                                    >
                                    </action-toolbar-buttons>
                                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                                    <grid-export [grid]="mainGrid" [name]="'Equipment Utilization'"></grid-export>
                                    <wj-multi-select
                                        name="monthFilterSandGravel"
                                        style="width: 200px"
                                        [placeholder]="'Filter by month'"
                                        (checkedItemsChanged)="applySandGravelMonthFilter()"
                                        [itemsSource]="monthFilterSandGravel"
                                        [displayMemberPath]="'display'"
                                        [checkedMemberPath]="'$checked'"
                                    ></wj-multi-select>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="mainGrid"
                                    #mainGrid
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="grid.initialize(mainGrid)"
                                    (destroy)="grid.destroy()"
                                    [itemsSource]="grid.view"
                                    (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                                    (pasting)="pasting(mainGrid, $event)"
                                    (pasted)="pasted(mainGrid, $event)"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Job'"
                                        [binding]="'job'"
                                        [dataMap]="jobMap"
                                        [width]="200"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Images'"
                                        [binding]="'imageUrls'"
                                        [cssClass]="'cell-img'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    >
                                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                            @for (url of cell.item.imageUrls; track url; let i = $index) {
                                                <img [src]="getExistingImageSrc(url)" (click)="openImage(url)" />
                                            }
                                        </ng-template>
                                    </wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Ticket Date'"
                                        [binding]="'date'"
                                        [width]="110"
                                        [format]="'d'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Ticket'"
                                        [binding]="'ticket'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Is Lessor'"
                                        [binding]="'isLessor'"
                                        [width]="100"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Invoiced'"
                                        [binding]="'isInvoiced'"
                                        [width]="100"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Invoice Number'"
                                        [binding]="'invoiceNumber'"
                                        [width]="130"
                                        [isRequired]="false"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Invoice Date'"
                                        [binding]="'invoiceDate'"
                                        [width]="130"
                                        [editor]="inputDate"
                                        [isRequired]="false"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Price'"
                                        [binding]="'price'"
                                        [width]="80"
                                        [format]="'c2'"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Extended Price'"
                                        [binding]="'extendedPrice'"
                                        [width]="120"
                                        [format]="'c2'"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Vendor'"
                                        [binding]="'vendor'"
                                        [width]="160"
                                        [dataMap]="aggVendorMap"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Pit'"
                                        [binding]="'pitName'"
                                        [width]="160"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Material'"
                                        [binding]="'materialName'"
                                        [width]="230"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Truck'"
                                        [binding]="'truck'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Trailer 1'"
                                        [binding]="'trailer1'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Trailer 2'"
                                        [binding]="'trailer2'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Qty'"
                                        [binding]="'quantity'"
                                        [width]="75"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Units'"
                                        [binding]="'units'"
                                        [width]="85"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Driver'"
                                        [binding]="'userHrRefOrVendorId'"
                                        [dataMap]="userMap"
                                        [width]="150"
                                        [isReadOnly]="true"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Notes'"
                                        [binding]="'notes'"
                                        [minWidth]="300"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
                                <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Haul Off</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="haulOffGrid"></action-toolbar-count>
                                    <action-toolbar-buttons
                                        [grid]="haulOffGrid"
                                        [canEdit]="canEdit"
                                        [showAdd]="true"
                                        [showEdit]="true"
                                        [showDelete]="true"
                                        [showDuplicate]="true"
                                    ></action-toolbar-buttons>
                                    <action-toolbar-search name="search" [(ngModel)]="haulOffGrid.filter"></action-toolbar-search>
                                    <grid-export [grid]="gridHaulOff" [name]="'Equipment Requests'"></grid-export>
                                    <wj-multi-select
                                        name="monthFilterHaulOff"
                                        style="width: 200px"
                                        [placeholder]="'Filter by month'"
                                        (checkedItemsChanged)="applyHaulOffMonthFilter()"
                                        [itemsSource]="monthFilterHaulOff"
                                        [displayMemberPath]="'display'"
                                        [checkedMemberPath]="'$checked'"
                                    ></wj-multi-select>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridHaulOff"
                                    #gridHaulOff
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="haulOffGrid.initialize(gridHaulOff)"
                                    (destroy)="haulOffGrid.destroy()"
                                    [itemsSource]="haulOffGrid.view"
                                    (cellEditEnded)="cellEditEnded(gridHaulOff, $event)"
                                    (pasting)="pasting(gridHaulOff, $event)"
                                    (pasted)="pasted(gridHaulOff, $event)"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Job'"
                                        [binding]="'job'"
                                        [dataMap]="jobMap"
                                        [width]="200"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Images'"
                                        [binding]="'imageUrls'"
                                        [cssClass]="'cell-img'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    >
                                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                            @for (url of cell.item.imageUrls; track url; let i = $index) {
                                                <img [src]="getExistingImageSrc(url)" (click)="openImage(url)" />
                                            }
                                        </ng-template>
                                    </wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date'"
                                        [binding]="'date'"
                                        [width]="110"
                                        [format]="'d'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Ticket'"
                                        [binding]="'ticket'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Invoiced'"
                                        [binding]="'isInvoiced'"
                                        [width]="100"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Invoice Number'"
                                        [binding]="'invoiceNumber'"
                                        [width]="130"
                                        [isRequired]="false"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Invoice Date'"
                                        [binding]="'invoiceDate'"
                                        [width]="130"
                                        [editor]="inputDate2"
                                        [isRequired]="false"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Price'"
                                        [binding]="'price'"
                                        [width]="80"
                                        [format]="'c2'"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Extended Price'"
                                        [binding]="'extendedPrice'"
                                        [width]="120"
                                        [format]="'c2'"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Vendor'"
                                        [binding]="'vendor'"
                                        [width]="160"
                                        [dataMap]="aggVendorMap"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Location'"
                                        [binding]="'pitName'"
                                        [width]="160"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Truck'"
                                        [binding]="'truck'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Trailer 1'"
                                        [binding]="'trailer1'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Trailer 2'"
                                        [binding]="'trailer2'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Qty'"
                                        [binding]="'quantity'"
                                        [width]="75"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Units'"
                                        [binding]="'units'"
                                        [width]="85"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Driver'"
                                        [binding]="'userHrRefOrVendorId'"
                                        [dataMap]="userMap"
                                        [width]="150"
                                        [isReadOnly]="true"
                                        [visible]="!isLessor()"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Notes (No Haul Off Fee Location)'"
                                        [binding]="'notes'"
                                        [minWidth]="300"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <wj-input-date #inputDate2 [isRequired]="false"></wj-input-date>
                                <grid-selection-calculation [grid]="gridHaulOff"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="3" [destroyOnHide]="false" [hidden]="isLessor()">
            <a ngbNavLink>Concrete</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="concreteGrid"></action-toolbar-count>
                                    <action-toolbar-buttons
                                        [grid]="concreteGrid"
                                        [canEdit]="canEdit"
                                        [showAdd]="true"
                                        [showEdit]="true"
                                        [showDelete]="true"
                                        [showDuplicate]="true"
                                    ></action-toolbar-buttons>
                                    <action-toolbar-search name="search" [(ngModel)]="concreteGrid.filter"></action-toolbar-search>
                                    <grid-export [grid]="gridConcrete" [name]="'Equipment Requests'"></grid-export>
                                    <wj-multi-select
                                        name="monthFilterConcrete"
                                        style="width: 200px"
                                        [placeholder]="'Filter by month'"
                                        (checkedItemsChanged)="applyConcreteMonthFilter()"
                                        [itemsSource]="monthFilterConcrete"
                                        [displayMemberPath]="'display'"
                                        [checkedMemberPath]="'$checked'"
                                    ></wj-multi-select>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridConcrete"
                                    #gridConcrete
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="concreteGrid.initialize(gridConcrete)"
                                    (destroy)="concreteGrid.destroy()"
                                    [itemsSource]="concreteGrid.view"
                                    (cellEditEnded)="cellEditEnded(gridConcrete, $event)"
                                    (pasting)="pasting(gridConcrete, $event)"
                                    (pasted)="pasted(gridConcrete, $event)"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Job'"
                                        [binding]="'job'"
                                        [dataMap]="jobMap"
                                        [width]="200"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Images'"
                                        [binding]="'imageUrls'"
                                        [cssClass]="'cell-img'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    >
                                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                            @for (url of cell.item.imageUrls; track url; let i = $index) {
                                                <img [src]="getExistingImageSrc(url)" (click)="openImage(url)" />
                                            }
                                        </ng-template>
                                    </wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date'"
                                        [binding]="'date'"
                                        [width]="130"
                                        [format]="'d'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Concrete Ticket'"
                                        [binding]="'ticket'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Pump Truck Ticket'"
                                        [binding]="'pumpTruckTicket'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Tester Ticket'"
                                        [binding]="'testingTicket'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Invoiced'" [binding]="'isInvoiced'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Invoice Number'"
                                        [binding]="'invoiceNumber'"
                                        [width]="130"
                                        [isRequired]="false"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Invoice Date'"
                                        [binding]="'invoiceDate'"
                                        [width]="130"
                                        [editor]="inputDate3"
                                        [isRequired]="false"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Concrete Type'"
                                        [binding]="'concreteType'"
                                        [width]="130"
                                        [dataMap]="concreteTypeMap"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Qty (Yards)'"
                                        [binding]="'quantity'"
                                        [width]="130"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Concrete Vendor'"
                                        [binding]="'vendor'"
                                        [dataMap]="concreteVendorsMap"
                                        [width]="230"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Pump Truck Vendor'"
                                        [binding]="'pumpTruckVendor'"
                                        [dataMap]="pumpTruckVendorMap"
                                        [width]="230"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Tester Vendor'"
                                        [binding]="'testingVendor'"
                                        [dataMap]="concreteTesterVendorMap"
                                        [width]="230"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Notes'"
                                        [binding]="'notes'"
                                        [minWidth]="300"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <wj-input-date #inputDate3 [isRequired]="false"></wj-input-date>
                                <grid-selection-calculation [grid]="gridConcrete"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="4" [destroyOnHide]="false" [hidden]="true">
            <a ngbNavLink>Other</a>
            <ng-template ngbNavContent> </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
